// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2dqvl","detailsBorder":"styles_detailsBorder__1FaHN"};